import React from 'react'
import { Badge } from '@/shared/ui'
import { supabase } from '@/lib/supabase'
import { bpsToPercent } from '../utils/percent'

type Props = {
  userId: string
}

export default function RevshareParticipantHeader({ userId }: Props) {
  const [name, setName] = React.useState<string | null>(null)
  const [email, setEmail] = React.useState<string | null>(null)
  const [status, setStatus] = React.useState<string | null>(null)
  const [shareBps, setShareBps] = React.useState<number>(0)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      setError(null)
      try {
        const [p, part] = await Promise.all([
          supabase.from('v_profiles_contact_master').select('full_name, email').eq('id', userId).maybeSingle(),
          supabase.from('revshare_participants').select('status, share_bps').eq('user_id', userId).maybeSingle(),
        ])
        if (!mounted) return
        if (p.error) throw p.error
        if (part.error) throw part.error
        setName((p.data as any)?.full_name ?? null)
        setEmail((p.data as any)?.email ?? null)
        setStatus((part.data as any)?.status ?? null)
        setShareBps(Number((part.data as any)?.share_bps || 0))
      } catch (e: any) {
        if (!mounted) return
        setError(e?.message || 'Falha ao carregar participante')
      }
    })()
    return () => {
      mounted = false
    }
  }, [userId])

  return (
    <div className="mb-6">
      <h1 className="text-2xl font-semibold">Detalhes do participante</h1>
      <p className="text-sm text-foreground/70">Visao completa de comissoes, payouts e dados bancarios.</p>

      {error && (
        <div className="mt-3 rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">
          {error}
        </div>
      )}

      <div className="mt-3 flex flex-wrap items-center gap-2">
        <Badge variant="soft" className="font-mono">
          {name || '-'}
        </Badge>
        <Badge variant="soft" className="font-mono">
          {email || userId}
        </Badge>
        {status && (
          <Badge variant="soft" className="capitalize">
            {status}
          </Badge>
        )}
        <Badge variant="soft" className="font-mono">
          Share: {bpsToPercent(shareBps, 2)}
        </Badge>
      </div>
    </div>
  )
}

